





































































































































































































































































































































































import Spinner from './components/Spinner'
UsaStates = require('usa-states').UsaStates
usStates = new UsaStates()
axios = require('axios')
dmas = require('./utils.js').dmas
retailers = require('./utils.js').retailers

apiHost = 'http://localhost:8000'
apiHost = 'https://dev-php-app.herokuapp.com' if window.location.host is 'dev-marketplace-api.herokuapp.com'
apiHost = 'https://live-php.herokuapp.com' if window.location.host is 'www.recess.is'

export default 
  name: 'home'
  components: { Spinner }
  data: ->
    averageSamples: null
    company: ''
    ctaEmail: null
    isCalculating: false
    isGenerating: false
    email: null
    phone: ''
    step: 1
    endDate: null
    startDate: null
    soldRetailers: []
    marketStates: []
    marketDmas: []
  computed:
    dmas: -> dmas
    retailers: -> retailers
    states: -> usStates.states
    endDayOptions: -> { disabledDate: @endDateIsInvalid }
    startDayOptions: -> { disabledDate: @startDateIsInvalid }
    beginYearOptions: -> { disabledDate: @beginYearIsInvalid }
  methods: 
    beginYearIsInvalid: (time) -> time.getFullYear() > (new Date(@startDate)).getFullYear()
    endDateIsInvalid: (time) -> time.getTime() < (new Date(@startDate)).getTime()
    startDateIsInvalid: (time) -> 
      return time.getTime() < Date.now() - 8.64e7 unless @endDate?
      return time.getTime() < Date.now() - 8.64e7 || time.getTime() > (new Date(@endDate)).getTime()
    calculate: ->      
      return window.alert 'Please select a start and end date.' unless (@startDate? and @endDate?)
      return window.alert 'Please provide a valid email address.' unless @email?
      if !@isCalculating
        @isCalculating = true
        setTimeout => 
          @isCalculating = false
          @step = 2
        , 1900
    generate: -> 
      if !@isGenerating
        @isGenerating = true
        try
          response = await axios.post(apiHost + '/api/samples/generate', {
            average_samples: @averageSamples,
            company: @company
            dmas: @marketDmas,
            email: @email,
            end_date: @endDate,
            phone: @phone,
            retailers: @soldRetailers,
            start_date: @startDate,
            states: @marketStates
          })
          @step = 3
        catch err 
          console.log err
        finally 
          @isGenerating = false
    finalCta: ->
      window.location.href = 'https://app.recess.is/register?market_type=buyer&email=' + @email + '&utm_campaign=Sampling%20Calculator&utm_source=website'
    footerCta: ->
      window.location.href = 'https://app.recess.is/register?market_type=buyer&email=' + @ctaEmail + '&utm_campaign=Sampling%20Calculator&utm_source=website'
  watch: 
    step: -> window.scrollTo 0, 0
